import * as React from "react";
import IGenericButtons from "../IGenericButtons";
import { RouteComponentProps } from "react-router-dom";
import IRedirectButton from "../UploadDocument/IRedirectButton";
import Tooltip from "src/components/common/Tooltip/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";
import * as _ from "lodash";

export default function RedirectButton(props: IRedirectButton & IGenericButtons & RouteComponentProps<any>) {
  const tradeId = props.redirectWithTradeId ? props.trade.id : "";
  const precatorioId = props.redirectWithPrecatorioId ? props.trade.precatorio.id : "";

  function getId() {
    if (props.redirectWithTradeId) {
      return tradeId
    }
    else if (props.redirectWithPrecatorioId) {
      return precatorioId
    }
    return ""
  }

  const url: string = `${props.urlRedirect}${getId()}`;
  const isDisabled = (_.isFunction(props.disabled) ? props.disabled(props.trade) : props.disabled);

  return (
    <Tooltip text={isDisabled ? props.tooltipTitleDisabled : props.tooltipTitle}>
      <button disabled={isDisabled} onClick={() => props.history.push(url)} className="redirect btn">
        <FontAwesomeIcon icon={props.icon} />
        {props.buttonText}
      </button>
    </Tooltip>
  );
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/RedirectButton/RedirectButton.tsx